(function () {
  if (window.informationPageProtectionLayoutsInitialized) {
    return;
  }

  window.informationPageProtectionLayoutsInitialized = true;

  function buildImagesById(imageItems, idKey) {
    var imagesById = {};

    imageItems.forEach(function (item) {
      var itemId = item.dataset[idKey];
      var imageSrc = item.dataset.imageSrc;

      if (!itemId || !imageSrc) {
        return;
      }

      imagesById[itemId] = {
        src: imageSrc,
        srcset: item.dataset.imageSrcset || ''
      };
    });

    return imagesById;
  }

  function updateMainImage(mainImage, imageData) {
    mainImage.src = imageData.src;

    if (imageData.srcset) {
      mainImage.srcset = imageData.srcset;
    } else {
      mainImage.removeAttribute('srcset');
    }
  }

  function bindInteractiveTriggers(triggers, imagesById, mainImage, idGetter) {
    function setActiveTrigger(activeTrigger) {
      triggers.forEach(function (trigger) {
        var isActive = trigger === activeTrigger;
        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function activateTrigger(trigger) {
      var triggerId = idGetter(trigger);
      var imageData = imagesById[triggerId];

      if (!imageData) {
        return;
      }

      updateMainImage(mainImage, imageData);
      setActiveTrigger(trigger);
    }

    triggers.forEach(function (trigger) {
      trigger.setAttribute('aria-pressed', 'false');

      trigger.addEventListener('mouseenter', function () {
        activateTrigger(trigger);
      });

      trigger.addEventListener('focus', function () {
        activateTrigger(trigger);
      });

      trigger.addEventListener('click', function () {
        activateTrigger(trigger);
      });
    });

    var initialTrigger = null;

    triggers.forEach(function (trigger) {
      if (!initialTrigger && imagesById[idGetter(trigger)]) {
        initialTrigger = trigger;
      }
    });

    if (initialTrigger) {
      activateTrigger(initialTrigger);
    }
  }

  function initProtectionLayouts(root) {
    var layouts = root.querySelectorAll('[data-protection-layout]');

    layouts.forEach(function (layout) {
      if (layout.dataset.protectionInitialized === 'true') {
        return;
      }

      var mainImage = layout.querySelector('.accordion-protection-layout__main-image');
      var productCards = layout.querySelectorAll('[data-protection-product-card]');
      var imageItems = layout.querySelectorAll('[data-protection-product-image]');

      if (!mainImage || !productCards.length || !imageItems.length) {
        return;
      }

      layout.dataset.protectionInitialized = 'true';

      bindInteractiveTriggers(
        productCards,
        buildImagesById(imageItems, 'productId'),
        mainImage,
        function (productCard) {
          return productCard.dataset.productId;
        }
      );
    });
  }

  function initProtectionColorLayouts(root) {
    var layouts = root.querySelectorAll('[data-protection-colors-layout]');

    layouts.forEach(function (layout) {
      if (layout.dataset.protectionColorsInitialized === 'true') {
        return;
      }

      var mainImage = layout.querySelector('.accordion-protection-layout__main-image');
      var swatches = layout.querySelectorAll('[data-protection-color-swatch]');
      var imageItems = layout.querySelectorAll('[data-protection-color-image]');

      if (!mainImage || !swatches.length || !imageItems.length) {
        return;
      }

      layout.dataset.protectionColorsInitialized = 'true';

      bindInteractiveTriggers(
        swatches,
        buildImagesById(imageItems, 'colorId'),
        mainImage,
        function (swatch) {
          return swatch.dataset.colorId;
        }
      );
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProtectionLayouts(document);
    initProtectionColorLayouts(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initProtectionLayouts(event.target);
    initProtectionColorLayouts(event.target);
  });
}());